import { fetchHandler } from '../fetchHandler'

export const authApi = {
  verify() {
    return fetchHandler('/auth/verify', {
      method: 'GET'
    })
  },
  login({ email, password }) {
    return fetchHandler('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    })
  }
}
